import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { Icons } from '@/font-awesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import LoaderAnimation from '../LoaderAnimation.vue';
import { ref, computed, onMounted, onUnmounted, getCurrentInstance } from 'vue';
import { ValueResult } from '@/models/value-result';
import { AddressModel } from '@/models/address_model';
import { vMaska } from "maska"

const labelLeft = 20;

export default /*@__PURE__*/_defineComponent({
  __name: 'AddressSelector',
  props: {
    prefixIcon: { type: Object, required: false },
    icon: { type: Object, required: false },
    iconButton: { type: Object, required: false },
    modelValue: { type: String, required: true },
    label: { type: String, required: true },
    supportingText: { type: String, required: false },
    state: { type: String, required: false },
    type: { type: String, required: false },
    mask: { type: String, required: false },
    tokenMask: { type: String, required: false },
    isStatic: { type: Boolean, required: false },
    options: { type: Array, required: false },
    fetchFunction: { type: Function, required: true }
  },
  emits: ["update:model-value", "tap-trailing", "leave-focus", "on-paste", "change:value", "select"],
  setup(__props: any, { expose: __expose }) {

_useCssVars(_ctx => ({
  "4f2c5451-inputBackgroundColor": (inputBackgroundColor.value)
}))

const props = __props;



__expose({
  setFocus: (v: boolean) => v ? inputField.value?.focus() : inputField.value?.blur(),
  clearOptions: () => {isFocused.value = false; options = []},
});

const thisInstance = getCurrentInstance();
const inputBefore = ref<HTMLElement | null>(null);
const labelElem = ref<HTMLElement | null>(null);
const currentLabelSize = ref(0);
const state = computed(() => props.state ?? 'default');
const isFocused = ref(false);
const isHovered = ref(false);
const isLoading = ref(false);
const floatOn = computed(() => isFocused.value || props.modelValue.length > 0)
const inputField = ref<HTMLInputElement | null>(null);
const inputBackgroundColor = computed(() => `var(--components-input-${state.value}-background-color, rgba(0, 0, 0, 0.00))`);
const loadingStep = ref<InstanceType<typeof LoaderAnimation>>();
const timeoutID = ref<number | undefined>(undefined);
let options: AddressModel[] | null = props.options ?? [];

function getState() {
  if (state.value == 'error') return state.value;
  if (isFocused.value) {
    return "focused";
  }
  if (isHovered.value && state.value != "disabled") {
    return "hovered";
  }
  return `${state.value}`;
}

function timedSearchAddress() {
  clearTimeout(timeoutID.value);
  timeoutID.value = setTimeout(searchAddress, 1000);
}

async function searchAddress() {
  if (inputField.value?.value?.length! !== 9) return;
  loadingStep.value?.startLoading({
    loading: {
      text: 'Pesquisando o endereço digitado...',
      subtext: 'Por favor, aguarde.',
    },
  });
  isLoading.value = true;
  const res = await props.fetchFunction();
  if (res.isSuccess()) {
    options = res?.getValue();
  }
  loadingStep.value?.endLoading({
    isError: res.isError(),
    error: {
      subtext: 'Endereço não encontrado.',
    },
    delayAfterLoaded: res.isError() ? 2000 : 0,
  });
  setTimeout(() => isLoading.value = false, res.isError() ? 2000 : 0);
}

function getOptionTitle(option: AddressModel): string {
  let title = '';
  const street = option.getStreet();
  const streetNumber = option.getStreetNumber();
  const complement = option.getComplement();
  if (street && street !== 'undefined') title += street;
  if (streetNumber && streetNumber !== 'undefined') title += (title ? ', ' : '') + streetNumber;
  if (complement && complement !== 'undefined') title += (title ? ', ' : '') + complement;
  return title;
}

function getOptionSubtitle(option: AddressModel): string {
  let subtitle = '';
  const vicinity = option.getVicinity();
  const city = option.getCity();
  const state = option.getState();
  if (vicinity && vicinity !== 'undefined') subtitle += vicinity;
  if (city && city !== 'undefined') subtitle += (subtitle ? ', ' : '') + city;
  if (state && state !== 'undefined') subtitle += (city && city !== 'undefined' ? '/' : subtitle ? ', ' : '') + state;
  return subtitle;
}

function isStatic(){
  if (props.isStatic === undefined || !props.isStatic){
    return false;
  }
  return true;
}

let resizeObserver: ResizeObserver | null = null;

onMounted(() => {
  resizeObserver = new ResizeObserver(() => {
    currentLabelSize.value = labelElem.value?.offsetWidth ?? 0;
  });
  resizeObserver.observe(labelElem.value!);
});

onUnmounted(() => {
  resizeObserver?.disconnect();
});


const __returned__ = { props, thisInstance, labelLeft, inputBefore, labelElem, currentLabelSize, state, isFocused, isHovered, isLoading, floatOn, inputField, inputBackgroundColor, loadingStep, timeoutID, get options() { return options }, set options(v) { options = v }, getState, timedSearchAddress, searchAddress, getOptionTitle, getOptionSubtitle, isStatic, get resizeObserver() { return resizeObserver }, set resizeObserver(v) { resizeObserver = v }, get Icons() { return Icons }, get FontAwesomeIcon() { return FontAwesomeIcon }, LoaderAnimation, get vMaska() { return vMaska } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})